<template>
    <div>
        <div class="flex">
            <div class="cabinet-product-swiper-thumbs">
                <swiper ref="slider-thumbs" :options="sliderThumbsOptions">
                    <swiper-slide
                        v-for="(image, index) in images"
                        :key="index"
                        :class="{
                            'swiper-slide-thumb-active': index === activeIndex
                        }"
                    >
                        <img
                            :src="image.url"
                            alt=""
                            class="cabinet-product-swiper-thumbs__img ofi"
                            @click="onSlideClick(index)"
                        />
                    </swiper-slide>
                </swiper>
            </div>

            <div class="cabinet-product-swiper-gallery">
                <swiper ref="slider-gallery" :options="sliderGalleryOptions">
                    <swiper-slide v-for="(image, index) in images" :key="index">
                        <img
                            :src="image.url"
                            alt=""
                            class="cabinet-product-swiper-gallery__img ofi"
                        />
                    </swiper-slide>
                </swiper>
            </div>
        </div>

        <div
            class="cabinet-product-swiper-pagination swiper-pagination d-md-none"
        >
            <span class="swiper-pagination-bullet"></span
            ><span class="swiper-pagination-bullet"></span>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
    name: 'SupplierDetailSwiper',
    components: {
        swiper,
        swiperSlide
    },
    props: {
        images: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            activeIndex: 0,
            sliderThumbsOptions: {
                direction: 'vertical',
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true
            }
        }
    },
    computed: {
        sliderThumbs() {
            return this.$refs['slider-thumbs']
                ? this.$refs['slider-thumbs'].swiper
                : null
        },
        sliderGallery() {
            return this.$refs['slider-gallery']
                ? this.$refs['slider-gallery'].swiper
                : null
        },
        sliderGalleryOptions() {
            return {
                spaceBetween: 10,
                slidesPerView: 1,
                // effect: 'fade',
                pagination: {
                    el: '.swiper-pagination'
                }
            }
        }
    },
    methods: {
        onSlideClick(index) {
            this.sliderGallery.slideTo(index)
            this.activeIndex = index
        }
    }
}
</script>
